import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-orders-report-header',
  templateUrl: './orders-report-header.component.html',
  styleUrls: ['./orders-report-header.component.css']
})
export class OrdersReportHeaderComponent {
  @Input() title = 'Reporte de OS';
  @Input() subtitle =
    'Consulta órdenes disponibles, filtra por proveedor/estado y abre el PDF.';
  @Input() resultCount = 0;
  @Input() loadedCount = 0;
  @Input() activeFilterCount = 0;
  @Input() isLoading = false;
  @Input() isLoadingMore = false;

  @Output() refresh = new EventEmitter<void>();
}
